<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('models')">Models</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
    </div>
    <trashed-message v-if="modelData.deleted_at" class="mb-6" @restore="restore">
      This model has been deleted.
    </trashed-message>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Name" />
            <select-input v-model="form.brand" :error="errors.brand" class="pr-6 pb-8 w-full lg:w-1/2" label="Brand">
                <option v-for="brand in brands" :key="brand.id" :value="brand.id" :selected="brand.id === form.brand">{{brand.name}}</option>
            </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
          <button v-if="!modelData.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Model</button>
          <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">Update Model</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  props: {
    errors: Object,
    modelData: Object,
    brands: Array,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        name: this.modelData.name,
        id: this.modelData.id,
        brand: this.modelData.brand,
        model: this.modelData.model
      },
    }
  },
  methods: {
    submit() {
      var data = new FormData()
      data.append('name', this.form.name || '')
      data.append('brand', this.form.brand || '')
      data.append('_method', 'put')

      this.$inertia.post(this.route('models.update', this.modelData.id), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {

          }
        },
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this Model?')) {
        this.$inertia.delete(this.route('models.destroy', this.modelData.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this Model?')) {
        this.$inertia.put(this.route('models.restore', this.modelData.id))
      }
    },
  },
}
</script>
